// removed by extract-text-webpack-plugin
module.exports = {"stickyBar":"stickyBar__2L_0h","relativeBar":"relativeBar__3o7p_","textCenterSmall":"textCenterSmall__3UkmA","cardQuicRead":"cardQuicRead__3CGNk"};


//////////////////
// WEBPACK FOOTER
// ./components/homePageNew/stickyHeader/stickyHeader.scss
// module id = 503
// module chunks = 68